<template>
  <div
    class="help-center-progress__component"
    :class="className"
  />
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  active: {
    type: Boolean,
    required: true
  }
})

const className = computed(() => {
  if (props.active) {
    return 'help-center-progress__component--active'
  } else {
    return null
  }
})
</script>

<style lang="scss">
.help-center-progress__component {
  width: 100%;
  height: 2px;
  opacity: 0;

  background-color: var(--help-center-highlight);
  transform: scaleX(0);
  transform-origin: left;

  &--active {
    opacity: 1;
    transform: scaleX(1);
    transition: opacity 0.2s ease-out, transform 0.4s easeOutExpo;
  }
}
</style>
